import type { TranscriptMessage } from "./types.js";

const MAX_TRANSCRIPT_MESSAGES = 100;

/** Merge a provider transcript event into the bounded UI transcript. */
export function appendTranscriptMessage(
  messages: readonly TranscriptMessage[],
  incoming: TranscriptMessage,
): TranscriptMessage[] {
  const next = [...messages];
  const last = next.at(-1);
  if (!incoming.text) {
    if (incoming.final && last && last.role === incoming.role && !last.final) {
      next[next.length - 1] = { ...last, final: true };
    }
    return next;
  }
  if (last && last.role === incoming.role && !last.final) {
    next[next.length - 1] = {
      role: incoming.role,
      text: incoming.final ? incoming.text : last.text + incoming.text,
      final: incoming.final,
    };
  } else {
    next.push({ ...incoming });
  }
  return next.slice(-MAX_TRANSCRIPT_MESSAGES);
}
